<template>
  <div class="g">
    <!-- 头部导航栏 -->
    <div class="litops orangeToYellow com_top">
      <!-- 设备名称 -->
      <span class="refresh" @click="handleRefresh">
        <span class="iconfont icon-shuaxin1" />
        <span class="txt">刷新数据</span>
      </span>
      <!-- 设备编号 -->
      <span class="tit">轮灌程序</span>
    </div>

    <!-- 顶部按钮组 -->
    <div class="g_ctn">
      <div class="g_opt">
        <div class="get" @click="handleControl('run')">
          <div class="circular">
            <span class="iconfont icon-yunduanshuaxin" />
          </div>
          <span class="text">启动程序</span>
        </div>
        <div class="get" @click="handleControl('end')">
          <div class="circular">
            <span class="iconfont icon-shezhi" />
          </div>
          <span class="text">停止程序</span>
        </div>
      </div>
    </div>

    <!-- 时间规划 -->
    <div class="show_time">
      <div class="item" v-for="item in showTime" :key="item.label">
        <div class="label">{{ item.label }}</div>
        <div class="value">{{ item.value }}</div>
      </div>
    </div>

    <!-- 设备分组 -->
    <div class="group">
      <div class="item card" v-for="(item, index) in pumpGroups" :key="`${index}_pumpGroups`">
        <div class="row1">
          <div class="r_t">
            <span class="cir">
              <span class="iconfont icon-shuibeng"></span>
            </span>
            <span class="name">{{ item.groupName }}</span>
          </div>
          <div class="r_b">
            <van-field :class="['inp' , pumpGroupsStatus[index] && pumpGroupsStatus[index].status && 'valve_active' ]" type="number" v-for="(valve,index) in item.valveList" :key="valve" :value="valve" disabled />
          </div>
        </div>
        <div class="row2"></div>
      </div>
    </div>

    <!-- RTU阀门分组 -->
    <div class="group valveGroups">
      <div :class="['item',  index <= currentGroup  && status && 'active']" v-for="(item, index) in valveGroups" :key="index">
        <!-- 进度条 -->
        <div class="left">
          <div class="cir">
            <div class="cir2"></div>
          </div>
          <div class="line" v-if="index + 1 !== valveGroups.length"></div>
        </div>
        <!-- 阀门 -->
        <div class="right">
          <div class="row row1">
            <div class="font">
              <i class="iconfont icon-shenghuoshuibengfang" />
            </div>
            <div>{{ item.groupName }}</div>
            <div class="txt">执行：{{ currentGroup == index ? opentime : 0}}</div>
            <div class="txt">时长：{{ item.min }}分钟</div>
          </div>
          <div class="row row2"></div>
          <div class="row row3" v-if="item.valve_group && item.valve_group.length">
            <div :class="['item_valve' , status && checkRTUValveActive(_item, index)  &&  'valve_active' ]" v-for="(_item, _index) in item.valve_group" :key="`${_index}_${_item}`">
              {{ _item }}
            </div>
          </div>
          <div class="row row4">
            <div class="font">
              <div class="yuan">
                <i class="iconfont icon-qiehuan"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      no: "",
      showTime: [
        {
          key: "totalDuration",
          label: "共计用时",
          value: "",
        },
        {
          key: "startTime",
          label: "开始时间",
          value: "",
        },
        {
          key: "surplusTime",
          label: "剩余时间",
          value: "",
        },
        {
          key: "endTime",
          label: "完成时间",
          value: "",
        },
      ],
      pumpGroups: [],
      valveGroups: [],
      prosId: null,
      status: null,
      pumpGroupsStatus: [],
      valveGroupsStaus: [],
      opentime: 0,
      currentGroup: null,
    };
  },

  async mounted () {
    const no = localStorage.getItem("no");
    this.no = no;

    await this.handleRefresh();


  },

  methods: {
    async handleRefresh () {
      try {
        this.$toast.loading({
          message: "数据加载中...",
          forbidClick: true,
          duration: 0
        })

        // 读取分组
        await this.getGroup();
        // 读取程序状态
        await this.getStatus();
        // 读取所有的阀门状态
        await this.getAllValveStatus();

        setTimeout(() => {
          let elm = this.$el.querySelectorAll(".active");
          console.log("elm:", elm);
          if (elm && elm.length) {
            const eleDom = [...elm]
            // const dom = elm[elm.length - 1];
            // const target = dom.getElementsByClassName("line");
            // console.log("elm:", target);
            eleDom.map((item, index) => {
              const target = item.getElementsByClassName("line");
              if (index === eleDom.length - 1) {
                target[target.length - 1].style.cssText =
                  "background: linear-gradient(to bottom,rgba(58, 106, 224, 1),rgba(53, 105, 233, 0.2)) !important";
              } else {
                target[target.length - 1].style.cssText = "background: rgba(58, 106, 224, 1) !important";
              }
            })
          }
        }, 100)


        this.$toast.clear()
      } catch (e) {
        this.$toast.clear()
      }
    },

    // 程序控制
    async handleControl (type) {
      this.$toast.loading({
        message: "操作执行中...",
        forbidClick: true,
        duration: 0
      })
      // no cmd[【命令=run-运行，pause-暂停，end-结束]  prosId
      await this.$api.lgV2_control(this.no, type, this.prosId).then(res => {


        this.$toast({
          message: res.errcode === 0 ? (type === "run" ? "启动成功" : "关闭成功") : res.errmsg,
          duration: 2000
        })
      });
    },

    // 获取分组
    async getGroup () {
      await this.$api.lgV2_getGroup(this.no).then((res) => {
        if (res.errcode === 0) {
          if (res.data) {
            const { pumpGroups, valveGroups, timer } = res.data;
            this.pumpGroups = [
              {
                groupName: "水泵",
                valveList: pumpGroups,
              },
            ];

            valveGroups.map((o, i) => {
              if (!o.groupName) {
                o.groupName = `第${i + 1}组`;
              }
              o.check = false;
              const t = o.timer ? o.timer / 60 : 0;
              o.min = String(t).indexOf(".") > -1 ? t.toFixed(2) : t;
            });

            this.valveGroups = [...valveGroups];
          }
        } else {
          this.$toast("查询分组:" + res.errmsg);
        }
      });
    },

    // 查询全部阀门的状态
    async getAllValveStatus () {
      await this.$api.lgV2_getAllValveStatus(this.no).then((res) => {
        if (res.errcode === 0) {
          const { pumpGroups, valveGroups } = res.data
          this.pumpGroupsStatus = pumpGroups
          this.valveGroupsStaus = valveGroups
        } else {
          this.$toast("查询程序状态:" + res.errmsg);
        }
      });
    },

    // 获取程序状态
    async getStatus () {
      await this.$api.lgV2_getProgramStatus(this.no).then((res) => {
        if (res.errcode === 0) {
          const {
            status,
            prosId,
            endTime,
            opentime,
            startTime,
            surplusTime,
            totalDuration,
            group
          } = res.data;
          this.status = status;
          this.prosId = prosId;

          const obj = {
            surplusTime: this.getTime(surplusTime),
            totalDuration: this.getTime(totalDuration),
            endTime: endTime,
            startTime: startTime,
            // opentime: this.getTime(opentime),
          };

          this.showTime.map((o) => {
            o.value = obj[o.key];
          });

          this.currentGroup = group

          // const t = opentime ? opentime / 60 : 0;
          // const time = String(t).indexOf(".") > -1 ? t.toFixed(2) : t;
          this.opentime = this.getTime(opentime)
        } else {
          this.$toast("查询程序状态:" + res.errmsg);
        }
      });
    },

    // RTU 阀门 去阀门状态中查找这个阀门是否开始 来渲染颜色
    checkRTUValveActive (valName, index) {
      if (!this.valveGroupsStaus || !this.valveGroupsStaus.length) return false
      const target = this.valveGroupsStaus.find(o => o.index === valName)
      if (target && target.status) return true
      return false
    },

    getTime (second) {
      second = Number(second);
      let h = 0,
        m = 0,
        s = 0;

      const u_h = 60 * 60;
      const u_m = 60;

      h = Math.floor(second / u_h);
      m = Math.floor((second - h * u_h) / u_m);
      s = second - h * u_h - m * u_m;

      const M = String(m).padStart(2, "0");
      const S = String(s).padStart(2, "0");
      if (h) {
        const H = String(h).padStart(2, "0");
        return `${H}:${M}:${S}`;
      }

      return `${M}:${S}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.g {
  background: rgba(241, 247, 255, 1) !important;
}
.com_top {
  font-size: 16px;
  color: #fff;
  padding: 20px 0;
  line-height: 100%;
  text-align: center;

  .refresh {
    position: absolute;
    left: 10px;

    .txt {
      margin-left: 6px;
    }
    .icon-shuaxin1 {
      font-size: 16px;
    }
  }

  .tit {
    font-size: 20px;
  }
}

.g_ctn {
  margin-bottom: 10px;

  .g_opt {
    display: flex;
    align-items: center;
    height: 55px;
    padding: 18px 28px;
    background: #ffffff;
  }

  .get {
    display: flex;
    flex: 1;
    align-items: center;

    &:first-child {
      border-right: 0.5px solid rgba(232, 232, 232, 1);
    }

    &:last-child {
      justify-content: center;
    }

    .text {
      font-size: 16px;
      margin-left: 11px;
    }

    .circular {
      width: 39px;
      height: 39px;
      background: linear-gradient(
        90deg,
        rgba(72, 119, 233, 1) 0%,
        rgba(25, 76, 201, 1) 100%
      );

      border-radius: 50%;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .icon-yunduanshuaxin,
    .icon-shezhi {
      font-size: 24px !important;
    }
  }
}

.show_time {
  display: flex;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 4px 4px rgba(30, 152, 246, 0.05);
  border-radius: 8px;
  font-size: 16px;
  margin: 10px;

  .item {
    flex: 1;
    text-align: center;
    border-right: 0.5px solid rgba(232, 232, 232, 1);

    &:last-child {
      border: none;
    }

    .label {
      color: rgba(51, 51, 51, 1);
      padding: 8px;
      border-bottom: 0.5px solid rgba(232, 232, 232, 1);
    }

    .value {
      color: rgba(136, 136, 136, 1);
      padding: 9px 0;
      font-size: 14px;
    }
  }
}

.card {
  background: rgba(255, 255, 255, 1);
  border-radius: 8px;
  padding: 10px 7px;
  margin-bottom: 12px;
  margin: 0 10px;

  .row1 {
    font-size: 14px;

    .r_t {
      display: flex;
      align-items: center;
      margin-bottom: 13px;
    }

    .txt {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 8px;
      padding-right: 10px;
    }

    .r_b {
      display: flex;

      .r_b_l {
        display: flex;
        flex: 1;
        flex-wrap: wrap;
      }

      .inp {
        width: 48px;
        height: 35px;
        border: 0.5px solid rgba(151, 151, 151, 1);
        border-radius: 4px;
        margin-right: 7px;
        // margin: 5px;
        padding: 8px !important;

        ::v-deep input {
          text-align: center !important;
        }
      }

      .cir {
        width: 26px;
        height: 26px;
        text-align: center;
        line-height: 26px;
        font-size: 24px;
        color: #ffffff;
        border-radius: 50%;
      }

      .reduce {
        background: rgba(214, 218, 221, 1);
        box-shadow: 0px 2px 2px rgba(229, 229, 229, 1);
      }

      .add {
        background: rgba(53, 102, 220, 1);
        box-shadow: 0px 2px 2px rgba(49, 171, 254, 0.2);
      }

      .value {
        font-size: 16px;
        color: rgba(51, 51, 51, 1);
        margin: 0 9px;
      }

      .btn {
        display: flex;
        align-items: center;
      }
    }

    .icon-shuibeng {
      font-size: 25px;
    }

    .cir {
      display: block;
      width: 32px;
      height: 32px;
      line-height: 32px;
      border-radius: 50%;
      background: rgba(59, 107, 224, 1);
      color: #ffffff;
      text-align: center;
    }

    .name {
      margin-left: 13px;
      font-size: 16px;
    }
  }
}

.valveGroups {
  background: #ffffff;
  margin: 10px;
  padding: 9px 11px;
  font-size: 16px;
  border-radius: 8px;

  .item {
    display: flex;

    .left {
      margin-right: 10px;
      padding-top: 23px;

      .cir {
        width: 18px;
        height: 18px;
        text-align: center;
        line-height: 18px;
        border-radius: 50%;
        padding: 6px 0 0 6px;
        background: rgba(216, 216, 216, 1);
      }
      .cir2 {
        width: 12px;
        height: 12px;
        background: #ffffff;
        border-radius: 50%;
      }

      .line {
        width: 5px;
        height: 100%;
        margin-left: 9px;
        background: rgba(216, 216, 216, 1);
      }
    }

    .right {
      flex: 1;
    }

    .row {
      display: flex;
      align-items: center;
      width: 100%;
    }
    .row1 {
      justify-content: space-between;
      padding-bottom: 11px;
      border-bottom: 0.5px solid rgba(232, 232, 232, 1);

      .font {
        width: 25px;
        height: 25px;
        line-height: 25px;
        text-align: center;
        border-radius: 50%;

        background: rgba(40, 89, 211, 1);

        i {
          color: #ffffff;
        }
      }

      .txt {
        color: rgba(151, 151, 151, 1);
        font-size: 14px;
      }
    }

    .row3 {
      display: flex;
      flex-wrap: wrap;
      margin: 20px 0;

      .item_valve {
        width: 42px;
        height: 31px;
        line-height: 31px;
        text-align: center;
        border: 0.5px solid rgba(151, 151, 151, 1);
        border-radius: 4px;
        margin-right: 10px;
        margin-bottom: 10px;
      }
    }

    .row4 {
      position: relative;
      width: calc(100% - 42px);
      height: 1px;
      border-bottom: 1px dashed rgba(216, 216, 216, 1);
      margin-bottom: 30px;

      .font {
        position: absolute;
        top: -21px;
        right: -42px;
        width: 42px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        background: rgba(216, 216, 216, 0.2);
        border-radius: 50%;

        .yuan {
          width: 30px;
          height: 30px;
          line-height: 30px;
          text-align: center;
          background: rgba(216, 216, 216, 1);
          border-radius: 50%;
          margin: 6px 0 0 6px;

          i {
            color: #ffffff;
          }
        }
      }
    }
  }

  .active {
    .cir {
      background: rgba(58, 106, 224, 1) !important;
    }

    .line {
      background: rgba(58, 106, 224, 1) !important;
    }

    .row4 {
      border-bottom: 1px dashed rgba(40, 89, 211, 1) !important;

      .font {
        background: rgba(30, 152, 246, 0.2) !important;
      }

      .yuan {
        background: rgba(58, 106, 224, 1) !important  ;
      }
    }
  }
}

::v-deep .van-field__control:disabled {
  color: #000 !important;
  -webkit-text-fill-color: #000;
}

//
.valve_active {
  color: #ffffff !important;
  background: rgba(58, 106, 224, 1) !important;
  border: 0.5px solid rgba(58, 106, 224, 1) !important;

  ::v-deep .van-field__control:disabled {
    color: #ffffff !important;
    -webkit-text-fill-color: #ffffff;
  }
}
</style>
